import CirclePlus from '../../src/legacy/CirclePlus.tsx';
export default CirclePlus;
